import BaseComponent from '../../../general/js/base-component';
import RadioSwitchComponent from '../../radio-switch/js/radio-switch.component';
import TimelineLite from 'gsap/TimelineLite';

export default class PageSwitchTabsComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        this.tabs = this.refs.tabs;

        this.onSwitch = this.onSwitch.bind(this);
        this.currentTab = null;
        this.inProgress = false;

        this.init();
    }

    static getRequiredRefs() {
        return ['tabs'];
    }

    init() {
        this.switcherElement = document.getElementById('page-switcher');
        if (this.switcherElement) {
            this.radioSwitcher = new RadioSwitchComponent(this.switcherElement, {
                id: 'page-switcher',
                props: {
                    onSwitch: this.onSwitch
                }
            });

            this.activate(this.radioSwitcher.getValue());
        }
    }

    onSwitch(e) {
        if (!this.inProgress) {
            this.activate(e.target.value);
        } else {
            this.newTabOpenedKey = e.target.value;
        }
    }

    activate(key) {
        if (key in this.tabs) {
            this.inProgress = true;
            let newTab = this.tabs[key];
            if (this.currentTab === null || this.currentTab !== newTab) {
                this.hideCurrentTab().then(() => {
                    //if a new tab had been activated during hiding process
                    //we activate it instead of newTab
                    if (this.newTabOpenedKey) {
                        let newKey = this.newTabOpenedKey;
                        this.newTabOpenedKey = null;
                        this.currentTab = null;
                        this.activate(newKey);
                    } else {
                        this.showTab(newTab);
                        this.currentTab = newTab;
                        this.inProgress = false;
                    }
                });
            }
        }
    }

    hideCurrentTab() {
        if (this.currentTab) {
            this.currentTab.classList.remove('is-visible');
            return new Promise((resolve) => {
                setTimeout(() => {
                    this.currentTab.classList.remove('is-active');
                    resolve();
                }, 400);
            });
        }
        return Promise.resolve();
    }

    showTab(tab) {
        (new TimelineLite()).staggerFrom(tab.querySelectorAll('.bidding-card'), 0.3, {
            y: '30px',
            ease: Power4.easeOut
        }, 0.1);

        tab.classList.add('is-active');
        tab.classList.add('is-visible');
    }
}



// WEBPACK FOOTER //
// ./app/components/page-switch-tabs/js/page-switch-tabs.component.js